import React from 'react';
import { testimonials } from '../data/testimonials';
import { SectionHeading } from './SectionHeading';
export function Testimonials() {
  const [lead, ...rest] = testimonials;
  return <section className="border-t border-ink-950/8 bg-canvas py-20 lg:py-28" data-id="element-226" data-mp="3fze45yusr5w7">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-227" data-mp="3fxb3mkw0pud8">
        <SectionHeading eyebrow="Owners" title="What our community says." lede={'Every Hydrosprings pool tells the same story \u2014 clarity, purity, and a life free from chlorine.'} data-id="element-228" data-mp="3azt4tnbpsviy" />

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.25fr_1fr]" data-id="element-229" data-mp="321z9aelry5wu">
          <figure className="flex flex-col rounded-2xl bg-ink-950 p-8 sm:p-10" data-id="element-230" data-mp="2x1kzos4iynwp">
            <blockquote className="font-display text-2xl font-medium leading-[1.25] tracking-tight text-white sm:text-[30px]" data-id="element-231" data-mp="2s2i5k2q3223i">
              &ldquo;{lead.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-auto pt-10 text-sm text-white/55" data-id="element-232" data-mp="q9u15q1pd8m5">
              <span className="text-white" data-id="element-233" data-mp="h5y6c818d10g">{lead.name}</span> &middot;{' '}
              {lead.location}
            </figcaption>
          </figure>

          <div className="grid gap-6" data-id="element-234" data-mp="m5syeewqrwn3">
            {rest.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-paper p-7 ring-1 ring-ink-950/8" data-id="element-235" data-mp="78aepqyx89mi">
                <blockquote className="text-[15px] leading-relaxed text-ink-800" data-id="element-236" data-mp="c8oj8z1bd1fs">
                  &ldquo;{item.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-auto pt-6 text-sm text-ink-600" data-id="element-237" data-mp="14u7p1135d8nd">
                  <span className="font-medium text-ink-950" data-id="element-238" data-mp="q7eiolblvd7b">{item.name}</span>{' '}
                  &middot; {item.location}
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}